import {
  BUTTON_STYLE_BY_STATUS,
  ButtonStyle,
  FOOTER_VARIANT_TYPE,
  ThemeKeyType
} from '@/components/AdvertisePayments/components/Footer/Footer.types';

export const buttonStyleByVariants: Record<ThemeKeyType, ButtonStyle> = {
  [BUTTON_STYLE_BY_STATUS.DEFAULT_LIGHT]: {
    background: 'var(--system-blue)',
    labelColor: 'var(--bg-main)'
  },
  [BUTTON_STYLE_BY_STATUS.DEFAULT_DARK]: {
    background: 'var(--system-blue)',
    labelColor: 'var(--textAndLabels-main)'
  },
  [BUTTON_STYLE_BY_STATUS.PREMIUM_LIGHT]: {
    background: 'var(--bg-premium)',
    labelColor: 'var(--bg-main)',
    labelColorTablet: 'var(--textAndLabels-main)'
  },
  [BUTTON_STYLE_BY_STATUS.PREMIUM_DARK]: {
    background: 'var(--bg-premium)',
    labelColor: 'var(--textAndLabels-main)',
    labelColorTablet: 'var(--bg-main)'
  }
};

const fallbackStyle: ButtonStyle = {
  background: 'inherit',
  labelColor: 'inherit'
};

export const getButtonStyle = (
  styledVariant: FOOTER_VARIANT_TYPE,
  isDark: boolean
): ButtonStyle => {
  if (!styledVariant) return fallbackStyle;

  const themeMode = isDark ? 'dark' : 'light';
  const key = `${styledVariant}_${themeMode}` as ThemeKeyType;

  return buttonStyleByVariants[key] ?? fallbackStyle;
};
